class cusDialog{
	constructor(title, message, yesCallback = "", noCallback = "", type = "Normal"){
		this.yesCallback 	= yesCallback;
		this.noCallback 	= noCallback;
		this.title			= title;
		this.popupHtml 		= '<div class="popuptext">'+ message +'</div><div class="popupBtnBar white"><button class="btn' + type + ' btnYes">Yes</button><button class="btnOptional btnNo">Cancel</button></div>';
		this.htmlObj		= $(this.popupHtml);
		this.cusDialogObj	= null;
	}
	
	open(){
		var self = this;

		this.cusDialogObj = new window.Popup(this.title, this.htmlObj);
		this.cusDialogObj.open();
		
		this.htmlObj.find('.btnYes').click(function() {
			if(self.yesCallback){self.yesCallback();}
			self.close();
		});		
		this.htmlObj.find('.btnNo').click(function() {
			if(self.noCallback){self.noCallback();}
			self.close();
		});
		
		this.htmlObj.find('.btnYes').focus().keypress(function (e) {
			// the enter key code
			if(e.which == 13){  
				this.htmlObj.find('.btnYes').trigger('click');
				return false;
			}
		});
	}
	
	close(){
		this.cusDialogObj.close();
	}
}

window.cusDialog = cusDialog;